import { GridOverlay } from '@mui/x-data-grid';
import React from 'react';

type CustomDataGridNoRowOverlayProps = {
  message: string;
};

const CustomDataGridNoRowOverlay: React.FC<CustomDataGridNoRowOverlayProps> = ({ message }) => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 300);
    return () => clearTimeout(timeout);
  }, []);

  if (!show) return null;
  return (
    <GridOverlay>
      <p>{message}</p>
    </GridOverlay>
  );
};

export default CustomDataGridNoRowOverlay;
